import { conditionOptionsMap, editorStateMap } from "./condition-options";
import { ActiveGoalButtonText } from "./conditions/ActiveGoalButtonText";

// Re-export the dependency-free constants so existing `./utils` importers keep
// working; the source of truth is the leaf `./condition-options` (no imports),
// which breaks the load-time import cycle (see that file's header).
export { conditionOptionsMap, editorStateMap };

export const conditionComponentsMap = {
  [conditionOptionsMap.ACTIVE_GOAL]: ActiveGoalButtonText,
};
